export default {
  site: {
    title: "蘑菇视频",
    subtitle: "短视频娱乐平台",
    description: "海量高清视频内容，流畅播放体验，丰富创作工具",
  },
  nav: {
    home: "首页",
    download: "下载安装",
    tutorial: "使用教程",
    features: "功能特色",
    faq: "常见问题",
    about: "关于我们",
  },
  hero: {
    title: "发现精彩，记录生活",
    subtitle: "蘑菇视频 —— 海量高清短视频内容平台，流畅播放体验，丰富创作工具，千万用户的选择",
    download: "立即下载",
    tutorial: "使用教程",
  },
};